import Vue from 'vue'
import Router from 'vue-router'
import VehicleMonitorData from '../pages/VehicleMonitorData.vue'
import AlertConfig from '../pages/AlertConfig.vue'
import InboundPlanManagement from '../pages/InboundPlanManagement.vue'
import NetworkPointList from '../pages/NetworkPointList.vue'
import UserAccountList from '../pages/UserAccountList.vue'
import ComponentTest from '../../examples/component-test/index.vue'
import CostBillCheck from '@/pages/CostBillCheck.vue'
import CostDiffRule from '@/pages/CostDiffRule.vue'
import CostDiffRuleAdd from '@/pages/CostDiffRuleAdd.vue'
import CostDiffHandle from '@/pages/CostDiffHandle.vue'
import CostDiffDetail from '@/pages/CostDiffDetail.vue'
import ImportExportResult from '@/pages/ImportExportResult.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/cost-diff-handle'
    },
    {
      path: '/vehicle-monitor/data',
      name: 'VehicleMonitorData',
      component: VehicleMonitorData
    },
    {
      path: '/vehicle-monitor/alert-config',
      name: 'AlertConfig',
      component: AlertConfig
    },
    {
      path: '/vehicle-monitor/inbound-plan-management',
      name: 'InboundPlanManagement',
      component: InboundPlanManagement
    },
    {
      path: '/network-point/list',
      name: 'NetworkPointList',
      component: NetworkPointList
    },
    {
      path: '/user-account/list',
      name: 'UserAccountList',
      component: UserAccountList
    },
    {
      path: '/cost-bill-check',
      name: 'CostBillCheck',
      component: CostBillCheck
    },
    {
      path: '/cost-diff-rule',
      name: 'CostDiffRule',
      component: CostDiffRule
    },
    {
      path: '/cost-diff-rule/add',
      name: 'CostDiffRuleAdd',
      component: CostDiffRuleAdd
    },
    {
      path: '/cost-diff-handle',
      name: 'CostDiffHandle',
      component: CostDiffHandle
    },
    {
      path: '/cost-diff-detail',
      name: 'CostDiffDetail',
      component: CostDiffDetail
    },
    {
      path: '/import-export-result',
      name: 'ImportExportResult',
      component: ImportExportResult
    },
    {
      path: '/component-test',
      name: 'ComponentTest',
      component: ComponentTest
    }
  ]
})

